import { Theme } from "@mui/material";

import makeStyles from "@mui/styles/makeStyles";

const styles = makeStyles((theme: Theme) => ({
  line: {
    borderTop: "1px solid #E0E2E7",
    marginTop: "20px",
    marginBottom: "20px",
    width: "100%",
  },
  icon: {
    marginRight: "5px",
  },
  flexColumn: {
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.down("sm")]: {
      marginBottom: "10px",
    },
  },
  flexColumnCenter: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      marginBottom: "10px",
    },
  },
  flexRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  dateRow: {
    marginRight: "10px",
  },
  columnInfo: {
    marginTop: "5px",
  },
  button: {
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  title: {
    fontFamily: "Manrope",
    fontSize: "16px",
    fontWeight: 700,
    lineHeight: "24px",
    color: "#465869",
  },
  description: {
    fontFamily: "Manrope",
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "24px",
    color: "#667085",
  },
  mainGrid: {
    marginTop: "20px",
  },
  modal: {
    maxWidth: "760px",
  },
}));

export default styles;
